export default __webpack_public_path__ + "static/media/19.2aef677b.png";